import { Box, Typography } from '@mui/material'
import React, { useState } from 'react'
import TableCustom from '../../component/table/tableCustom';
import { icons } from '../../constants/images';
import TableRowCommon from '../../component/table/TableRowCommon';
import { LayoutTitle, LayoutView, TitleText } from '../../component/layout/layoutMainStyle';
import { useNavigate } from 'react-router-dom';

export default function Report() {
    const navigate = useNavigate()
    const [data, setData] = useState<any>([
        {
            name: 'สถิติแยกตามสกุลไฟล์',
            path: '/report-summary-by-file-extention'
        },
        {
            name: 'สถิติแยกตามประเภทเอกสาร',
            path:'/report-summary-by-document-type'
        },
        {
            name: 'สถิติแยกตามแยกตามสำนัก',
            path:'/report-summary-by-department'
        },
        {
            name: 'สถิติแยกตามปีงบประมาณ',
            path:'/report-summary-by-fiscalyear'
        },
        {
            name: 'รายงานไฟล์ทั้งหมดในระบบ',
            path:'/report-all-files'
        },
    ])
    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(5);
    const [rowCount, setRowCount] = useState<number>(3);
    const [totalPages, setTotalPages] = useState<number>(3);
    const [totalItem, setTotalItem] = useState<number>(60);
    const headCells = [
        {
            id: "no",
            label: 'ลำดับ',
            align: "center",
            colSpan: 1,
            width: '58px'
        },
        {
            id: "CreateDate",
            label: 'รายงาน',
            align: "left",
            colSpan: 1,
        },
        {
            id: "action",
            disablePadding: false,
            align: "center",
            colSpan: 1,
        },
    ];


    const renderData = (objData: any, index: any) => {
        const { name, path } = objData;
        index = page * pageLimit - pageLimit + index + 1;

        const objRenderData = {
            key: index,
            id: index,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: index },
                { option: "TEXT", align: "left", label: name },
                {
                    option: "COMPONENT",
                    align: "center",
                    component: (

                        <div style={{ cursor: "pointer", display: 'flex', alignItems: 'center', width: '100px' }}><icons.eyePasswordInput style={{ marginRight: "12px", width: "25px" }} onClick={() => {navigate(path)}} />
                            <Typography>ดู</Typography>
                            {/* {Permission.find((x: any) => x.MenuCode === 'Employee.Update').Permit &&
                                <Link to={`/employee/update-employee/${EmployeeId}`}>
                                    <Button variant='contained' color='warning'>ดู</Button>
                                </Link>
                            } */}
                        </div>
                    )
                }

            ],

        }


        return (
            <TableRowCommon
                {...objRenderData}
                ondocumentdetail={() => { }}
            />
        )
    };
    return (
        <LayoutView>
            <LayoutTitle>
                <TitleText>รายงาน</TitleText>
            </LayoutTitle>
            <TableCustom
                headCells={headCells}
                customScroll
                page={page}
                pageLimit={pageLimit}
                sortType={"ASC"}
                sortBy=""
                rowCount={rowCount}
                rowsData={data?.map((d: any, index: any) => {
                    return renderData(d, index);
                })}
                onSort={() => { }}
                setPageLimit={(value: number) => setPageLimit(value)}
                setPage={(value: number) => setPage(value)}
                totalPages={totalPages}
                totalItem={totalItem}
                hidePagination
            />
        </LayoutView>
    )
}
